class SocialPosts {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/community/social-posts`;
    this.apiClient = apiClient;

  }

  async getSocialPosts(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async performSocialPostAction(socialPostId, provider, data) {

    const path = this.basePath + '/:socialPostId/social-actions/:provider';

    return this.apiClient.post(path, { socialPostId, provider }, {}, data);

  }

  async getSocialPostReactions(socialPostId, provider) {

    const path = this.basePath + '/:socialPostId/social-reactions/:provider';

    return this.apiClient.get(path, { socialPostId, provider }, {});

  }

  async getSocialPostCommentSuggestions(socialPostId, provider, senderAccountId) {

    const path = this.basePath + '/:socialPostId/social-comment-suggestions/:provider/:senderAccountId';

    return this.apiClient.get(path, { socialPostId, provider, senderAccountId }, {});

  }

  async regenerateSocialPostCommentSuggestions(socialPostId, provider, senderAccountId) {

    const path = this.basePath + '/:socialPostId/social-comment-suggestions/:provider/:senderAccountId';

    return this.apiClient.post(path, { socialPostId, provider, senderAccountId }, {}, {});

  }

}

export default SocialPosts;
